var escape = require("../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".error[data-v-8ad58668] {\n  color: rgba(255, 0, 0, 0.6) !important;\n}\n.error-ctrl[data-v-8ad58668] {\n  background-color: rgba(255, 0, 0, 0.16) !important;\n}\nbutton.notselect[data-v-8ad58668] {\n  cursor: default;\n  pointer-events: none;\n  border-color: #dedede;\n  color: #dedede;\n  background: url(" + escape(require("Image/ico-add-lightgray.png")) + ") no-repeat right 1.5em center;\n}\nbutton.notselect img[data-v-8ad58668] {\n  opacity: 0.1;\n}\n.attention[data-v-8ad58668] {\n  width: 100%;\n  color: #d83030;\n}", ""]);

// exports
